import { ApiMananger } from "./apiMananger";

const villeApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    getVilles: build.query({
      query: () => `/villes/`,
      providesTags: ["Villes"],
    }),
    getVille: build.query({
      query: (id) => `/villes/${id}/`,
      providesTags: ["Villes"],
    }),
  }),
});

export const {
  useGetVillesQuery,
  useGetVilleQuery,
} = villeApi;
